import { styled, tooltipClasses } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import type { TooltipProps } from '@mui/material/Tooltip/Tooltip';
import type { PropsWithChildren } from 'react';

export interface IFrontTooltip extends TooltipProps {
  disabled?: boolean;
}

export const FrontTooltip = ({ children, disabled, ...rest }: PropsWithChildren<IFrontTooltip>) => {
  return (
    <DarkTooltip
      disableFocusListener={disabled}
      disableHoverListener={disabled}
      disableTouchListener={disabled}
      placement={'auto'}
      {...rest}
    >
      {children}
    </DarkTooltip>
  );
};

const DarkTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.mainColors.titan900,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.mainColors.titan900,
    color: theme.mainColors.titan25,
    padding: '8px',
    fontSize: '14px',
    fontFamily: 'Telka, sans-serif',
    fontWeight: 400,
    borderRadius: '8px',
    lineHeight: '16px',
    maxWidth: '400px',
  },
}));
